import { Button, Popup } from 'semantic-ui-react';
import CarrierLogo from 'components/CarrierLogo/CarrierLogo';
import './agency-toggle-button.scss';

export default function AgencyToggleButton({
  agency,
  active,
  onToggle = () => {},
}) {
  return (
    <Popup
      role="tooltip"
      className="base-tooltip"
      key={agency.id}
      content={agency.agency_name || agency.outvio_agency}
      trigger={
        <Button
          className="agency-toggle-button"
          toggle
          active={active}
          onClick={(event, data) => {
            onToggle(!data.active);
          }}
        >
          <CarrierLogo code={agency.agency_code} />
        </Button>
      }
    />
  );
}
